import { render, staticRenderFns } from "./openOrClose.vue?vue&type=template&id=28fcc5ae&"
import script from "./openOrClose.vue?vue&type=script&lang=js&"
export * from "./openOrClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports